import { FC, useEffect, useRef, useState } from 'react'
import classnames from 'classnames'
import Modal from '../../common/components/modal'
import { IonCard, IonCardContent, IonText } from '@ionic/react'
import Button from '../../common/components/Button'
import { fetchAudio } from 'mobile_web/common_lib/utils'
import strings from 'mobile_web/strings'
import '../styles/answerModal.less'

interface AnswerModalProps {
	isOpen: boolean
	onClose: () => void
	imageSrc?: string
	audioSrc?: string
	text?: string
	isCorrect: boolean
}

const AnswerModal: FC<AnswerModalProps> = ({ isOpen, onClose, isCorrect, imageSrc, text, audioSrc }) => {
	const [resolvedAudioSrc, setResolvedAudioSrc] = useState(null)

	useEffect(() => {
		if (audioSrc && audioSrc.includes('/quality_7/')) {
			fetchAudio(audioSrc).then((audio) => {
				if (audio) {
					setResolvedAudioSrc(audio)
				}
			})
		}
	}, [audioSrc])


	return (
		<Modal
			isOpen={isOpen}
			onDidDismiss={onClose}
			preventNavigate={true}
			cssClass={classnames('answer-modal', { '-correct': isCorrect })}
		>
			<IonCard>
				<IonCardContent>
					{imageSrc && (
						<div className="answer-modal-image">
							<img src={imageSrc} alt="" />
						</div>
					)}
					<div className={classnames('answer-modal-text', { '-no-image': !imageSrc })}>
						<i className={`far fa-${isCorrect ? 'circle-check' : 'circle-xmark'}`} />
						<IonText>{text}</IonText>
					</div>
					<Button fill="clear" ariaLabel={strings.close} onClick={onClose}>
						{strings.close}
					</Button>
					{resolvedAudioSrc && isOpen ? <audio className="ion-hide" src={resolvedAudioSrc} ref={(ref) => {
						if (ref) {
							ref.play()
						}
					}} /> : null}
				</IonCardContent>
			</IonCard>
		</Modal>
	)
}

export default AnswerModal
